import { ChartsToolbarZoomInTrigger, ChartsToolbarZoomOutTrigger } from '@mui/x-charts-pro';
import { chartsToolbarClasses, Toolbar, ToolbarButton } from '@mui/x-charts';
import { Stack, Tooltip } from '@mui/material';
import { ZoomIn, ZoomOut } from '@mui/icons-material';

export function CustomToolbar() {
  return (
    <Stack
      onClick={(e) => e.stopPropagation()}
      sx={{
        width: 'fit-content',
        position: 'absolute',
        right: 5,
        top: 8,
        opacity: 1,
        pointerEvents: 'auto',
        [`& .${chartsToolbarClasses.root}`]: {
          minHeight: 'fit-content',
          width: '100%',
          justifyContent: 'space-between',
          flex: 1,
          m: 0,
        },
      }}
    >
      <Toolbar>
        <Tooltip title="Zoom in">
          <ChartsToolbarZoomInTrigger render={<ToolbarButton size="small" />}>
            <ZoomIn />
          </ChartsToolbarZoomInTrigger>
        </Tooltip>
        <Tooltip title="Zoom out">
          <ChartsToolbarZoomOutTrigger render={<ToolbarButton size="small" />}>
            <ZoomOut />
          </ChartsToolbarZoomOutTrigger>
        </Tooltip>
      </Toolbar>
    </Stack>
  );
}
